import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@mui/material';
import Iconify from 'src/components/iconify';

export default function RealTimeButton({ realTimeState, setRealTimeState, hasRealTimeButton, triggerRefresh }) {

  const handleRealTime = () => {
    setRealTimeState((prev) => {
      const next = !prev;
      if (next) triggerRefresh?.(); // liga e já refaz agora
      return next;
    });
  };

  return (
    <IconButton
      size="medium"
      color="primary"
      onClick={handleRealTime}
      sx={{
        width: 40,
        height: 40,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        '&:hover': {
          bgcolor: 'primary.dark',
          cursor: 'pointer',
          tooltip: 'Real Time',
        },
        display: hasRealTimeButton ? 'flex' : 'none',
        boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.33)'
      }}
    >
      <Iconify
        icon={ realTimeState ? "solar:clock-circle-bold" : "solar:clock-circle-outline" }
      />
    </IconButton>
  );
}

RealTimeButton.propTypes = {
    realTimeState: PropTypes.bool,
    setRealTimeState: PropTypes.func,
    hasRealTimeButton: PropTypes.bool,
    triggerRefresh: PropTypes.func,
  };


